import React, { useState, useEffect, useContext, useRef } from 'react';
import { Loader } from '../../atoms/loader';
import { AppContext } from '../../../context';
import { themeColor } from '../../layout/global-style';

export const PageTransition = ({children}) => {      
    const {autoStartPage, pageTransition, darkTransition, setDarkTransition } = useContext(AppContext);

    const [loading, setLoading] = useState(true);
    const [revers, setRevers] = useState(true);
    const refTimer = useRef();

    useEffect(() => {
        return () => {
            clearTimeout(refTimer.current);
            refTimer.current = null;
        }
    }, [])
    
    useEffect(() => {
        clearTimeout(refTimer.current);
        setRevers(darkTransition);    
        if (autoStartPage || pageTransition ) { 
            console.log ("setLoading(true)");
            setLoading(true);
        } else if (loading) {
            refTimer.current = setTimeout(()=>{ 
                setLoading(false);      
                setDarkTransition(null,-1);
            }, 1000);         
        }        
    }, [autoStartPage, pageTransition])

    return (
        <Loader isFull isTransitionMode={false} isLoading={loading} top={'auto'} zIndex={2000000001} revers={revers} bgColor={themeColor.white } color={themeColor.black} >
            {children}
        </Loader >                
    )
}